import { Util } from "../util.js";
import isToggleActive from "../toggles/toggles.js";
import { wishlist } from "@otto-ec/nexus-registry/wishlist";
import { WishlistHeartV1 } from "../wishlistheart_v1.js";

const util = new Util();
export class Article {
	constructor(dom) {
		this._dom = dom;
		this._id = util.readFromDataAttribute(dom, "article_id");
		this._variationId = util.readFromDataAttribute(dom, "variation_id");
		this._articlePosition = util.readFromDataAttribute(dom, "article_position");
		this._useWishlistHeartV1 = isToggleActive("ENABLE_OLD_WISHLIST_HEART", ".combo-modal");
		this._wishlistHeartV1 = this._useWishlistHeartV1 ? this.createWishlistHeartV1() : null;
	}

	createWishlistHeartV1() {
		const className = "combo-modal-article__wishlistheart-v1";
		const wishlistHeartDom = this._dom.querySelector("." + className);
		const comboType = util.readFromDataAttribute(wishlistHeartDom, "combo_type");
		const wishlistHeartV1 = new WishlistHeartV1(
			this._dom,
			className,
			wishlist,
			this._variationId,
			{ comboType },
			false
		);
		wishlistHeartV1.addClickHandlerForWishlistBtn();
		return wishlistHeartV1;
	}

	getId() {
		return this._id;
	}

	getVariationId() {
		return this._variationId;
	}

	getArticlePosition() {
		return this._articlePosition;
	}

	getOnWishlist() {
		if (this._useWishlistHeartV1) {
			return this._wishlistHeartV1.onWishlist;
		}
		return this._getOnWishlistV2();
	}

	_getOnWishlistV2() {
		this._wishlistHeartDom = this._dom.querySelector(".combo-modal-article__wishlistheart");
		const iconButton = this._wishlistHeartDom?.querySelector("oc-icon-button-v3");
		return iconButton?.classList.contains("ofc-wishlist-save-button-v1--transparent-filled") ?? false;
	}
}
